(function ($) {

    // pie-chart tab dropdown
    $( document ).ready(function() {

        var tabcounter = 1;
        $(".pie-chart-tab").each(function() {
            $(this).attr('data-tabnr', tabcounter);
            $(this).attr('id', 'tbnr-' + tabcounter);
            tabcounter++;
        });

        var imagecounter = 1;
        $(".field--name-field-pie-chart img").each(function() {
            $(this).addClass( 'image-nr' + imagecounter);
            imagecounter++;
        });

        $( '.image-nr0' ).toggleClass('show');
        $( "div[data-tabnr='0']" ).toggleClass('open');
        $( "div[data-tabnr='0']" ).find('.field--name-field-tab-titel').toggleClass('open');

    });

    $('.pie-chart-tab .field--name-field-tab-titel').click(function () {
        var datatabnr = $(this).parent('.pie-chart-tab').attr('data-tabnr');
        var imgtarget = 'open' + datatabnr;
        if ( $('.pie-chart-paragraph').hasClass( imgtarget )) {
            $('.pie-chart-paragraph').removeClass( imgtarget );
        } else {
            $(this).closest('.pie-chart-paragraph').removeClass('open1 open2 open3 open4').addClass(imgtarget);
        }
    });

// pie-chart effect
    $('.field--name-dynamic-token-fieldparagraph-imagemap .hover-img-1').hover(
        function(){ $(this).closest('.pie-chart-paragraph').addClass('hover1') },
        function(){ $(this).closest('.pie-chart-paragraph').removeClass('hover1') }
    );
    $('.field--name-dynamic-token-fieldparagraph-imagemap .hover-img-2').hover(
        function(){ $(this).closest('.pie-chart-paragraph').addClass('hover2') },
        function(){ $(this).closest('.pie-chart-paragraph').removeClass('hover2') }
    );
    $('.field--name-dynamic-token-fieldparagraph-imagemap .hover-img-3').hover(
        function(){ $(this).closest('.pie-chart-paragraph').addClass('hover3') },
        function(){ $(this).closest('.pie-chart-paragraph').removeClass('hover3') }
    );
    $('.field--name-dynamic-token-fieldparagraph-imagemap .hover-img-4').hover(
        function(){ $(this).closest('.pie-chart-paragraph').addClass('hover4') },
        function(){ $(this).closest('.pie-chart-paragraph').removeClass('hover4') }
    );

    $('.field--name-dynamic-token-fieldparagraph-imagemap .hover-img-1').click(function () {
        $(this).closest('.pie-chart-paragraph').removeClass('open1 open2 open3 open4').addClass('open1');
    });
    $('.field--name-dynamic-token-fieldparagraph-imagemap .hover-img-2').click(function () {
        $(this).closest('.pie-chart-paragraph').removeClass('open1 open2 open3 open4').addClass('open2');
    });
    $('.field--name-dynamic-token-fieldparagraph-imagemap .hover-img-3').click(function () {
        $(this).closest('.pie-chart-paragraph').removeClass('open1 open2 open3 open4').addClass('open3');
    });
    $('.field--name-dynamic-token-fieldparagraph-imagemap .hover-img-4').click(function () {
        $(this).closest('.pie-chart-paragraph').removeClass('open1 open2 open3 open4').addClass('open4');
    });
})(jQuery);
